"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHelpCircularHollow(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm10.015 6.34611a2.51955 2.51955 0 0 1 -.93 1.79 1.99113 1.99113 0 0 0 -.78992 1.5h-1.11008a2.92148 2.92148 0 0 1 1.12-2.29c.78686-.67739.62127-1.96-.38-1.96-.63324.02175-.74.69627-.74 1.28h-1.2a2.8677 2.8677 0 0 1 .68-2.09 2.04145 2.04145 0 0 1 3.35 1.77zm-1.5196 4.80527a.74526.74526 0 1 1 -.74526-.74526.74525.74525 0 0 1 .74526.74526zm-.4954-9.65027a6.49889 6.49889 0 1 1 -6.4989 6.49889 6.50625 6.50625 0 0 1 6.4989-6.49889m0-1.5a7.99889 7.99889 0 1 0 7.9989 7.99889 7.99889 7.99889 0 0 0 -7.9989-7.99889z' })));
}
exports.default = SvgHelpCircularHollow;
